/*
 * STEALS: no celular a ordenacao mora em radios dentro do drawer de filtro
 * (SHO-24). O resto do tema continua lendo o <select id="SortBy"> da barra --
 * o onSubmitHandler do facets.js pula inputs chamados sort_by de proposito.
 * Este arquivo so mantem os dois em sincronia; quem recarrega a grade continua
 * sendo o FacetFiltersForm.
 *
 * Delegado no document porque o drawer e re-renderizado a cada filtro
 * aplicado: um listener por radio morreria na primeira troca.
 */
(() => {
  document.addEventListener('change', (event) => {
    const radio = event.target;
    if (!radio.classList || !radio.classList.contains('steals-sort-option__input')) return;

    const select = document.getElementById('SortBy');
    if (!select || select.value === radio.value) return;

    select.value = radio.value;
  });
})();
